import { FishingEvent } from "./fishing-event.model";
import { GroundfishDelivery } from "./groundfish-delivery.model";
import { HMSDelivery } from "./hms-delivery.model";

export enum DeliveryStatus {
  New = 'new',
  Edited = 'edited',
  Submitted = 'submitted',
  SubmittedErrors = 'submitted_errors'
}

/**
 * Trip class, contains HMS and Groundfish deliveries and fields common to both
 */
export class Trip {

  status: DeliveryStatus = DeliveryStatus.New;

  //List of associated Fishing Events/Sets, slightly different between HMS and Groundfish
  sets: FishingEvent[] = [];

  groundfishDelivery: GroundfishDelivery = new GroundfishDelivery();

  hmsDelivery: HMSDelivery = new HMSDelivery();

  constructor() { }


  setValues(anon: any) {
    //Assign all values of anon to this object
    this.sets = (anon.sets as any[]).map(s => FishingEvent.transformAnonymous(s));
    this.groundfishDelivery = GroundfishDelivery.transformAnonymous(anon.groundfishDelivery);
    this.hmsDelivery = HMSDelivery.transformAnonymous(anon.hmsDelivery);
  }

}
